import { render, staticRenderFns } from "./PledgeDialog.vue?vue&type=template&id=835ea15c&scoped=true"
import script from "./PledgeDialog.vue?vue&type=script&lang=js"
export * from "./PledgeDialog.vue?vue&type=script&lang=js"
import style0 from "./PledgeDialog.vue?vue&type=style&index=0&id=835ea15c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835ea15c",
  null
  
)

export default component.exports